import React from "react";

// components imports
import { useSelector } from "react-redux";
import CommonLayout from "../../../../../components/_utils/CommonLayout";
import PanDetails from "../../../../../components/_utils/AccountCreationComponents/PanDetails";
import GstDetails from "../../../../../components/_utils/AccountCreationComponents/GstDetails";
import BankDetails from "../../../../../components/_utils/AccountCreationComponents/BankDetails";
import LinkEntityCard from "../../../../../components/_utils/LinkEntityCard";
import CategoriesEdit from "../../../../../components/_utils/AccountCreationComponents/CategoriesEdit";
import AssignLabels from "../../../../../components/_utils/AccountCreationComponents/AssignLabels";
import AdditionalRecipients from "../../../../../components/_utils/AccountCreationComponents/AdditionalRecipients";
import ConfidentialCard from "../../../../../components/_utils/TransactionCommonComponents/ConfidentialCard";
import ContactDetails from "../../../../../components/_utils/AccountCreationComponents/ContactDetails";

// images imports

import TEXT from "../../../../../utils/globalText";
import ICONS from "../../../../../assets/Icons";

const CreateConfirm = React.memo(
  ({ payload, selectedFields, recipients, manualVirtualAccount }) => {
    const categories = useSelector(
      (state) => state.sharedResources?.categoriesData?.categories,
    );

    return (
      <>
        <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base">
          <CommonLayout>
            <div className="flex flex-col gap-gap-md">
              <PanDetails
                panNumber={payload?.panNumber}
                legalName={payload?.legalName}
                previewMode={true}
              />

              <BankDetails
                payload={payload}
                previewMode={true}
              />

              {manualVirtualAccount && (
                <div>
                  <ConfidentialCard
                    icon={ICONS.VIRTUAL_ACCOUNT}
                    title={TEXT?.MARK_VIRTUAL_ACCOUNT}
                    note={TEXT?.VIRTUAL_ACCOUNT_NOTE}
                    toggleState={manualVirtualAccount}
                    isPreview={true}
                  />
                </div>
              )}

              <CategoriesEdit
                sortedCategories={categories}
                selectedCategories={categories
                  .filter((x) => selectedFields.includes(x.id))
                  .map((x) => x.id)}
                Title="Categories"
                isPreview={true}
              />

              <AdditionalRecipients
                previewMode={true}
                recipients={recipients}
              />
            </div>
            <div className="flex flex-col gap-gap-md">
              <GstDetails
                previewMode={true}
                gstin={payload?.gstin}
                gst_org_name={payload?.gst_org_name}
              />

              <ContactDetails
                previewMode={true}
                payload={payload}
                accountName={payload?.account_name}
                contactNumber={payload?.contact_no}
                emailId={payload?.email_id}
              />

              <LinkEntityCard
                payload={payload}
                previewMode={true}
                isOptional={true}
              />
              <AssignLabels
                previewMode={true}
                labels={payload?.labels}
                isOptional={true}
              />
            </div>
          </CommonLayout>
        </div>
      </>
    );
  },
);

export default CreateConfirm;
